import Content from './components/Content';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';
import * as styles from './styles';
import FocusableBackButton from '@components/FocusableBackButton';
import { useSignInContext } from '@context/SignIn';

const SignInView = () => {
  const { checkSignInSuccess } = useSignInContext();

  const { ref, focusKey, focusSelf } = useFocusable();

  useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  useEffect(() => {
    checkSignInSuccess();
  }, [checkSignInSuccess]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} css={styles.container}>
        <div css={styles.backgroundImage} />
        <div css={styles.contentContainer}>
          <FocusableBackButton />
          <Content />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default SignInView;
